<div [@formExplainAnimation]>
  <ng-content></ng-content>
</div>